query File($id: ID!) {
  file(id: $id) {
    id
    url
  }
}
